export const formatRoleCategory = (category) => {
  if (!category) return;
  if (category === 'user') return 'Permissões gerais';
  if (category === 'client') return 'Portal do cliente';
  if (category === 'broker') return 'Portal do corretor';
  if (category === 'admin') return 'Administração do sistema';
  if (category === 'backoffice') return 'Portal backoffice';
  if (category === 'menu') return 'Visualizar menus';
};
